// extracted by mini-css-extract-plugin
export default {"item":"Item-module--item--Qbcya","content":"Item-module--content--1Cq6E","imageWrapper":"Item-module--imageWrapper--tZVzt","image":"Item-module--image--z1vkM"};